<template>
  <div>
    <md-field :class="getValidationClass('password')">
      <label for="password">New Password</label>
      <md-input type="password"
		name="password"
		id="password"
		v-model="form.password"
		:disabled="sending"></md-input>
      <span class="md-error" v-if="!$v.form.password.required">New password required.</span>
      <span class="md-error" v-else-if="!$v.form.password.minLength">Password must be at least 8 character long.</span>
    </md-field>
    <md-field :class="getValidationClass('repeatPassword')">
      <label for="repeat-password">Repeat Password</label>
      <md-input type="password"
		name="repeat-password"
		id="repeat-password"
		v-model="form.repeatPassword"
		:disabled="sending"></md-input>
      <span class="md-error" v-if="!$v.form.repeatPassword.required">Please repeat the password.</span>
      <span class="md-error" v-else-if="!$v.form.repeatPassword.sameAsPassword">Password must match.</span>
      
    </md-field>
    <md-progress-bar md-mode="indeterminate" v-if="sending" />
    <md-card-actions>
      <md-button type="submit" class="md-primary" :disabled="sending" @click="validateAndSend">Send</md-button>
    </md-card-actions>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import {
  required,
  minLength,
  sameAs
} from 'vuelidate/lib/validators'

import { mapState, mapActions } from 'vuex'

export default {

  mixins: [validationMixin],

  data() {
    return {
      form: {
	password: null,
	repeatPassword: null
      }
    }
  },

  validations: {
    form: {
      password: {
        required,
	minLength: minLength(8)
      },
      repeatPassword: {
        required,
	sameAsPassword: sameAs('password')
      } 
    }
  },
  

  computed: {
    ...mapState(['pin', 'sending', 'password', 'uuid', 'notification', 'showNotification'])
  },

    
  
  methods: {
    getValidationClass (fieldName) {
      const field = this.$v.form[fieldName]
      
      if (field) {
        return {
            'md-invalid': field.$invalid && field.$dirty
          }
      }
    },
    ...mapActions(['changePassword']),
    async validateAndSend() {
      this.$v.$touch()

      if (!this.$v.$invalid) {
	await this.changePassword(this.form.password)
      }
    }
  }
}
</script>
